export enum PriceListType {
	Date = 1,
    Quota = 2,
    DateAndQuota = 3
}



// WEBPACK FOOTER //
// ./src/app/models/price-list-type.enum.ts